module.exports = __webpack_public_path__ + "media/app/components/Footer/BigIcon.75622d26.svg";